import React from 'react';
import { Form, Row, Col, TimePicker, Select, Radio, Divider } from 'antd';
import WrapperSelect from 'common/components/select/WrapperSelect';
import ReportingDownloadScheduleMonthSetting from './ReportingDownloadScheduleMonthSetting';
import ReportingDownloadScheduleWeekSetting from './ReportingDownloadScheduleWeekSetting';
import { TIME_ZONES } from 'static/TimeZones';
import { SCHEDULE_FORM_LAYOUT } from 'common/components/modal-download-folder/constants';
const { Option } = Select;
const ReportingDownloadScheduleForm = () => {
  const form = Form.useFormInstance();
  const interval = Form.useWatch('intervalType', form);
  return (
    <div className='reporting__schedule-settings'>
      <Row wrap={false}>
        <Col span={12}>
          <Form.Item
            {...SCHEDULE_FORM_LAYOUT}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
            name='runAt'
            label='Run at'
            rules={[
              {
                required: true,
                message: 'This field is required',
              },
            ]}
          >
            <TimePicker
              format={'HH:mm:ss'}
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='easterOrUserLocal'
            label=''
            rules={[
              {
                required: true,
                message: 'This field is required',
              },
            ]}
          >
            <WrapperSelect
              showSearch
              placeholder='Please choose timezone'
              optionFilterProp='children'
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {TIME_ZONES.map((zone) => (
                <Option key={zone.text} value={zone.utc[0]}>
                  {zone.text}
                </Option>
              ))}
            </WrapperSelect>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name='intervalType' label='Interval' {...SCHEDULE_FORM_LAYOUT}>
        <Radio.Group style={{ width: '100%' }}>
          <Row>
            <Col span={8}>
              <Radio value={'Daily'}>Daily</Radio>
            </Col>
            <Col span={8}>
              <Radio value={'Weekly'}>Weekly</Radio>
            </Col>
            <Col span={8}>
              <Radio value={'Monthly'}>Monthly</Radio>
            </Col>
          </Row>
        </Radio.Group>
      </Form.Item>
      <Divider
        style={{ margin: '0px auto 16px', minWidth: '60%', width: '60%' }}
      />
      {interval === 'Weekly' ? <ReportingDownloadScheduleWeekSetting /> : null}
      {interval === 'Monthly' ? (
        <ReportingDownloadScheduleMonthSetting />
      ) : null}
    </div>
  );
};
export default ReportingDownloadScheduleForm;
